import script from "./InformationTabView.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationTabView.vue?vue&type=script&setup=true&lang=ts"

import "./InformationTabView.vue?vue&type=style&index=0&id=361387cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-361387cc"]])

export default __exports__